import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { StratifyDocument } from "@stratify/shared";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectProperties } from "../../../../properties/store/propertiesSelectors";
import { updateDocumentStrataPlanStart } from "../../../store/documentsSlice";

interface PropertyStrataPlanSelectProps {
  document: StratifyDocument;
}

export const PropertyStrataPlanSelect: React.FC<
  PropertyStrataPlanSelectProps
> = ({ document }) => {
  const dispatch = useDispatch();
  const properties = useSelector(selectProperties);
  const [editedStrataPlanNumber, setEditedStrataPlanNumber] = useState(
    document.metadata.strataPlanNumber || ""
  );

  const handleChange = (event: SelectChangeEvent) => {
    const newStrataPlanNumber = event.target.value;
    setEditedStrataPlanNumber(newStrataPlanNumber);
    dispatch(
      updateDocumentStrataPlanStart({
        documentId: document.id,
        strataPlanNumber: newStrataPlanNumber,
      })
    );
  };

  // Get unique strata plan numbers
  const uniqueStrataPlanNumbers = Array.from(
    new Set(
      properties
        .map((property) => property.strataPlanNumber)
        .filter((number): number is string => number !== undefined)
    )
  ).filter((number) => number !== editedStrataPlanNumber);

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="strata-plan-select-label">Strata Plan Number</InputLabel>
      <Select
        data-testid="document-strata-plan"
        labelId="strata-plan-select-label"
        id="strata-plan-select"
        value={editedStrataPlanNumber}
        label="Strata Plan Number"
        onChange={handleChange}
      >
        <MenuItem value={editedStrataPlanNumber}>
          {editedStrataPlanNumber || "-"}
        </MenuItem>
        {uniqueStrataPlanNumbers.map((strataPlanNumber) => (
          <MenuItem key={strataPlanNumber} value={strataPlanNumber}>
            {strataPlanNumber}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
